import React, { forwardRef, useState } from 'react';
import DatePickerReact, { ReactDatePickerProps } from 'react-datepicker';
import { CalendarBlank } from 'phosphor-react';
import { ptBR } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

import { DatePickerContainer, DatePickerStyle } from './styles';

type ButtonProps = React.HTMLProps<HTMLButtonElement>;
export type DatePickerDateProps = ReactDatePickerProps;

const DatePickerCustomInput = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ value, onClick }) => {
    return (
      <DatePickerContainer
        className="datepicker-custom-input"
        onClick={onClick}
        type="button"
      >
        <span className={`${value === '' && '$gray700'}`}>
          {value === '' ? 'dd/mm/aaaa' : value}
        </span>
        <div className="calendar">
          <CalendarBlank />
        </div>
      </DatePickerContainer>
    );
  },
);

export const DatePickerDate: React.FC<DatePickerDateProps> = ({ ...props }) => {
  const [selectedDate, useSelectedDate] = useState<Date | null>(new Date());
  return (
    <DatePickerStyle>
      <DatePickerReact
        selected={selectedDate}
        dateFormat="dd/MM/yyyy"
        locale={ptBR}
        customInput={<DatePickerCustomInput />}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        {...props}
        maxDate={new Date()}
        onChange={(date) => useSelectedDate(date)}
      />
    </DatePickerStyle>
  );
};
